import dayjs from '@api/services/tools/dayjs';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AccessToken, AccessTokenPayload, AccessTokenType } from '@dev/ee-api/ee-api-models';
import { push as Push } from 'redux-first-history';
import { ApplicationState as State } from '@api/store';
import { HideDialog, UpdateDialog, ShowDialog } from '@api/store/dialog/actions';
import { ShowDialogParams } from '@api/store/dialog/types';
import {
    AccessTokenAdd,
    AccessTokenDelete,
    AccessTokensLoadingStart,
    AccessTokenUpdate,
    ChangeAccessToken,
    HideAccessTokenCredentials,
} from '@api/store/security/actions';
import { ResendActivationEmail } from '@api/store/auth/actions';
import { ManageAccessTokens as SettingsModule } from '@dev/ee-modules';
import { SettingsPaths } from '@api/services/dictionaries/paths';
import { compose } from 'redux';
import { ShowToastParams } from '@api/store/toast/types';
import { ShowToast } from '@api/store/toast/actions';

import { AccessTokensProps as Props } from '../AccessTokenInterface';

const mapState = (state: State, ownProps: Props): Props => {
    return {
        ...ownProps,
        account: state.account,
        browser: state.browser,
        dialog: state.dialog,
        security: state.security,
    };
};
const dispatchProps = {
    HideDialog,
    ShowDialog,
    UpdateDialog,
    AccessTokensLoadingStart,
    AccessTokenAdd,
    AccessTokenDelete,
    AccessTokenUpdate,
    ChangeAccessToken,
    HideAccessTokenCredentials,
    Push,
    ResendActivationEmail,
    ShowToast,
};
interface DispatchProps {
    HideDialog(): void;
    ShowDialog(params: ShowDialogParams): void;
    UpdateDialog(params: ShowDialogParams): void;
    AccessTokensLoadingStart(): void;
    AccessTokenAdd(accessToken: AccessToken): void;
    AccessTokenDelete(name: string, type: AccessTokenType): void;
    AccessTokenUpdate(name: string, body?: AccessTokenPayload): void;
    ChangeAccessToken(name: string, type: AccessTokenType): void;
    HideAccessTokenCredentials(): void;
    ResendActivationEmail?(params: { Email: string }): any;
    ShowToast?(params: ShowToastParams): void;

    Push(url: string): void;
}

type ExtendedProps = Props & DispatchProps;

class ManageAccessTokens extends Component<ExtendedProps> {
    render(): JSX.Element {
        return <SettingsModule dayjs={dayjs} paths={SettingsPaths} {...this.props} />;
    }
}

export default compose(connect<Props, DispatchProps>(mapState, dispatchProps))(ManageAccessTokens);
